import s from 'styled-components';

export const Wrap = s.section`
  margin-top: 110px;
  @media(max-width: 400px) {
    margin-top: 70px;
  }
`;
export const List = s.ul`
  display: flex;
  max-width: 1366px;
  margin: 0 auto;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 65px;
  li {
    color: var(--font-color-emp);
  }
  @media(max-width: 700px) {
    margin-top: 45px;
  }
`;
